module.exports = __webpack_public_path__ + "static/img/china.fdac042.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/screen38496/influence-zone/china.png
// module id = B6+u
// module chunks = 1